/**
 * Where the game lives, and where the public site lives.
 *
 * On the web the game is at `/play` and `/` is the static landing site (`packages/site`, served by
 * the server), which also owns `/rules`, `/privacy`, `/terms` and `/discord`. Inside Discord the
 * Activity still launches at `/?frame_id=…` and the server hands it the game there, so the game's
 * home is `/` when embedded. See docs/landing/PLAN.md.
 */
import { isEmbedded } from '../bridge/embedded';

export const GAME_PATH = '/play';

/** The public site. Absolute because inside Discord the iframe's own origin is Discord's proxy. */
export const SITE_ORIGIN = 'https://spadesnight.com';

type Loc = { hostname: string; search: string };

/** The pathname the game answers on this load: `/` inside Discord, `/play` on the web. */
export function gameHome(loc: Loc | undefined = globalThis.location): string {
  return isEmbedded(loc) ? '/' : GAME_PATH;
}

/** Is `path` (trailing slashes already stripped) the game's own address on this load? */
export function isGamePath(path: string, loc: Loc | undefined = globalThis.location): boolean {
  return path === gameHome(loc);
}

/**
 * A link to a page on the public site.
 *
 * Root-relative on the web, where the site is same-origin. Absolute inside Discord, where the only
 * way out of the iframe is the bridge's `openExternalLink`, and a relative URL would resolve against
 * Discord's proxy.
 */
export function siteUrl(path: string, loc: Loc | undefined = globalThis.location): string {
  return isEmbedded(loc) ? `${SITE_ORIGIN}${path}` : path;
}
